import { storage } from "@utils:token-storage";
import axios, { AxiosRequestConfig } from "axios";
import applyCaseMiddleware from "axios-case-converter";

/*
 * Convert snake_case to camelCase and vice versa for axios request and response
 */
const axiosIns = applyCaseMiddleware(
  axios.create({
    baseURL: window.location.origin,
  }),
);

axiosIns.interceptors.request.use((config) => {
  const token = storage.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosIns.interceptors.response.use(
  (res) => res.data,
  (error) => {
    if (error.response?.status === 401) {
      storage.clearToken();
      window.location.replace(window.location.origin);
    }
    return Promise.reject(error);
  },
);

export const get = async <T>(
  url: string,
  params?: Record<string, any>,
  config?: Omit<AxiosRequestConfig, "params">,
): Promise<T> =>
  await axiosIns.get(url, {
    params,
    ...config,
  });

export const post = async <T>(
  url: string,
  data?: Record<string, any> | string,
  config?: AxiosRequestConfig,
): Promise<T> => await axiosIns.post(url, data, config);

export const del = async <T>(
  url: string,
  params?: Record<string, any>,
  config?: AxiosRequestConfig,
): Promise<T> =>
  await axiosIns.delete(url, {
    params,
    ...config,
  });

export const patch = async <T>(
  url: string,
  data?: Record<string, any>,
  config?: AxiosRequestConfig,
): Promise<T> => await axiosIns.patch(url, data, config);

export const put = async <T>(
  url: string,
  data?: Record<string, any>,
  config?: AxiosRequestConfig,
): Promise<T> => await axiosIns.put(url, data, config);
